"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Manifest = exports.ProductManifestItem = exports.SolutionResponse = exports.Status = void 0;
const S = __importStar(require("@effect/schema/Schema"));
const productId_1 = require("./datatypes/productId");
/**
 * What is the current published state of a single Product for a particular
 * solution
 */
exports.Status = S.Literal(
/**
 * We're unable to determine the current status of the product - the
 * product's attributes aren't in the database
 */
'Unknown', 
/**
 * Fixtuur is aware of the product, and everything is in place for
 * publishing, but it is not currently available on the solution
 */
'Unpublished', 
/**
 * The product is available on the solution and everything it needs to exist
 * already exists.
 */
'Ready to Publish', 
/**
 * The product is available on the solution, but there are missing pieces
 * which could lead to the product breaking if accessed by a user.
 */
'Incomplete');
exports.SolutionResponse = S.Struct({
    status: exports.Status,
    details: S.Struct({ reason: S.String }),
});
exports.ProductManifestItem = S.Struct({
    aspect: exports.SolutionResponse,
    '3dxInspiration': exports.SolutionResponse,
    '3dxConfiguration': exports.SolutionResponse,
    content: S.extend(exports.SolutionResponse, S.Struct({
        config: S.optional(S.Struct({
            '360': S.optional(S.String),
            studio: S.optional(S.Array(S.String)),
            thumbnail: S.optional(S.Array(S.String)),
        })),
    })),
});
exports.Manifest = S.Record({
    key: S.String.pipe(S.fromBrand(productId_1.ProductId)),
    value: exports.ProductManifestItem,
});
